export default __webpack_public_path__ + "5044a0c7628c2c60c84f9a2e62337f68.webp";